import {Component, Inject, OnInit} from '@angular/core';

import {AlertService, AuthenticationService, ComplianceAreaService} from '../../_services/index';

import {Bulletin, ComplianceArea} from '../../_models/index';

import {LoginHelper} from '../../helpers/index';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BulletinService} from "../../_services/bulletin.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    standalone: false,
  selector: 'control-item-component',
  templateUrl: 'create.bulletin.html',
  styleUrls: ['./create.bulletin.css'],
})

export class CreateBulletinComponent implements OnInit {
  loading = false;
  bulletin: Bulletin = new Bulletin();
  complianceAreas: ComplianceArea[];
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CreateBulletinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public authenticationService: AuthenticationService,
    public bulletinService: BulletinService,
    public alertService: AlertService,
    public complianceAreaService: ComplianceAreaService,
    public formBuilder: FormBuilder) {
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.complianceAreaService.getInfoComplianceAreas(this.bulletin.tenantName).subscribe(complianceAreas => {
      this.complianceAreas = complianceAreas;
    });

    this.form = this.formBuilder.group({
      areaIds: [[], Validators.required],
      name: ['', Validators.required],
      type: ['', Validators.required],
      date: ['', Validators.required],
      article: ['', Validators.required],
      analysis: ['', Validators.required],
      recommendedActions: ['', Validators.required],
    });
  }

  onSave() {

    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach(field => { // {1}
        const control = this.form.get(field);            // {2}
        control.markAsTouched({ onlySelf: true });       // {3}
      });
      return;
    }

    this.loading = true;

    this.alertService.clear();

    this.bulletin.tenantName = LoginHelper.getTenantName();

    this.bulletinService.create(this.bulletin)
      .subscribe(
        data => {
          this.alertService.success('The item data was created.', true);
          this.loading = false;

          this.onClose();
        },
        error => {
          this.loading = false;
          const message = "An error occurred while creating item.";
          this.alertService.error(message);
        });
  }

  onClose(): void {
    this.dialogRef.close(this.bulletin);
  }
}
